export class FilesToRemoveAreNotFromTheSameRecording extends Error {
  constructor() {
    super(
      'The files are from different recorders or from different dates.' +
        ' These must be entered in separate removal requests.',
    )
    Object.setPrototypeOf(this, FilesToRemoveAreNotFromTheSameRecording.prototype)
  }
}
